<template>
	<div>
		<div class="row">
			<div class="col-md-9">
				<ul class="list-group user-account-group">
					<li class="list-group-item">
						<div v-if="last_nm">
							<span v-if="visible_user_is_sys_admin">
								<a @click.stop="showUserList" href="#">{{ last_nm }}, {{ first_nm }} </a>
							</span>
							<span v-else>
								{{ last_nm }}, {{ first_nm }}
							</span>

							<span v-show="is_locked == 1" class="label label-locked m-l-5">
								<span class="fa fa-lock m-r-5"></span> Locked</span>
							<span v-show="status_cd == 'IN'" class="label label-inactive m-l-5">
								<span class="fa fa-user m-r-5"></span> Inactive</span>
							<span v-show="hasPendingApproval" class="label label-warning m-l-5">Waiting Approval</span>
						</div>

						<div v-else> <!--no name-->
							<span v-if="visible_user_is_sys_admin">
								<a @click.stop="showUserList" href="#">No User Details</a>
							</span>
							<span v-else>
								No User Details
							</span>

							<span v-show="is_locked == 1" class="label label-locked m-l-5">
								<span class="fa fa-lock m-r-5"></span> Locked</span>
							<span v-show="status_cd == 'IN'" class="label label-inactive m-l-5">
								<span class="fa fa-user m-r-5"></span> Inactive</span>
							<span v-show="hasPendingApproval" class="label label-warning m-l-5">Waiting Approval</span>
						</div>

						<a @click.stop="" :href="'mailto:' + email"><span class="fa fa-envelope-o m-r-5"></span>{{ email
						}}</a> {{ user_details }}
						<div v-show="last_nm">Last Login: {{ (last_login_ts ? last_login_ts : 'Never') }}</div>
					</li>

					<account-role-item v-for="(role, index) in filtered_roles" :type="'approval'"
						:role_cd="role.role_cd" :role_desc="role.role_desc" :user_account_roles="local_roles_array"
						:source="'account'" :is_unavailable="isRoleUnavailable(role.role_cd)"
						@add="addRolesArray(index)" @delete="deleteRolesArray(index)">
					</account-role-item>

				</ul>
			</div>
			<div class="col-md-1 m-t-15">
				<span v-if="form_errors.length" class="simple-error"> {{ form_errors }} </span>
				<span v-if="form_status" class="simple-status"> {{ form_status }} </span>
			</div>
			<div class="col-md-2 m-t-15">
				<div class="pull-right">
					<button v-show="rolesChanged" @click="savePermissions" class="btn btn-primary btn-bold m-l-10"
						:disabled="saving">
						<i class="fa fa-check"></i>Save Changes
					</button>
					<button v-if="hasPendingApproval && !rolesChanged" @click="savePermissions"
						class="btn btn-warning btn-bold m-l-10" :disabled="saveDisabled">
						<i class="fa fa-close"></i>Deny Approvals
					</button>
				</div>
			</div>
		</div>
		<hr>
	</div>
</template>

<script>
module.exports = {
	props: [
		'user_id',
		'first_nm',
		'last_nm',
		'account_nbr',
		'status_cd',
		'is_locked',
		'last_login_ts',
		'email',
		'phone1',
		'city',
		'state_cd',
		'roles_array',
		'all_roles',
		'visible_user_is_sys_admin',
		'visible_user_id',
		'actor_is_auth_ad_on_this_account',
		'sole_admin_self',
	],
	data: function () {
		return {
			form_errors: {},
			form_status: "",
			local_roles_array: [],
			saving: false
		}
	},
	computed: {
		filtered_roles() {
			if (this.visible_user_is_sys_admin) return this.all_roles;
			return this.all_roles.filter(r => r.role_cd !== 'AUTH_AD');
		},
		user_details() {
			return this.last_nm ?
				'- ' + this.phone1 + ' - ' + this.city + ', ' + this.state_cd :
				'';
		},
		hasPendingApproval() {
			return Object.entries(this.local_roles_array).some(([role, status]) => status === 1);
		},
		rolesChanged() {
			if (Object.keys(this.local_roles_array).length !== Object.keys(this.roles_array).length) {
				return true;
			}

			return Object.entries(this.local_roles_array).some(([role, status]) => !this.roles_array.hasOwnProperty(role) || this.roles_array[role] !== status);
		},
		isSelfAuthorizedAdmin: function () {
			const hasAuthAd =
				this.local_roles_array.hasOwnProperty('AUTH_AD') &&
				(this.local_roles_array['AUTH_AD'] === 0 || this.local_roles_array['AUTH_AD'] === 1);
			return hasAuthAd && this.user_id && this.visible_user_id && (this.user_id === this.visible_user_id);
		},

		saveDisabled: function () { return this.saving || this.isSelfAuthorizedAdmin; },

		targetHasAuthAdFromBackend() {
			return (
				this.roles_array &&
				this.roles_array.hasOwnProperty('AUTH_AD') &&
				(this.roles_array['AUTH_AD'] === 0 || this.roles_array['AUTH_AD'] === 1)
			);
		},

		targetHasAuthAdEffective() {
			return this.targetHasAuthAdFromBackend ||
				(this.local_roles_array['AUTH_AD'] === 0 || this.local_roles_array['AUTH_AD'] === 1);
		},
	},
	watch: {
		roles_array() {
			this.copyRolesArray();
		}
	},
	methods: {
		copyRolesArray() {
			this.local_roles_array = _.clone(this.roles_array);
			if (!this.targetHasAuthAdFromBackend) {
				this.ensureAuthorizedConstraints();
			}
		},
		ensureAuthorizedConstraints() {
			const AUTH = 'AUTH_AD';
			const GROUPS = ['SUP', 'ANLYSIS', 'RPRT'];
			if (!this.local_roles_array.hasOwnProperty(AUTH)) return;

			if (this.local_roles_array.hasOwnProperty('BILL')) {
				Vue.delete(this.local_roles_array, 'BILL');
			}

			const hasAnyGroup = GROUPS.some(cd => this.local_roles_array.hasOwnProperty(cd));
			if (!hasAnyGroup) {
				GROUPS.forEach(cd => {
					if (!this.local_roles_array.hasOwnProperty(cd)) {
						Vue.set(this.local_roles_array, cd, 0);
					}
				});
			}
		},

		checkAllExceptAuthAdAndSelf() {
			const EXCLUDE = new Set(['AUTH_AD', 'ACT_ADM']);

			this.all_roles.forEach(r => {
				const cd = r.role_cd;

				if (EXCLUDE.has(cd)) return;
				if (this.isRoleUnavailable(cd)) return;
				if (this.local_roles_array.hasOwnProperty(cd)) return;

				Vue.set(this.local_roles_array, cd, 0);
			});
		},

		isRoleUnavailable(role_cd) {
			if (role_cd === 'BILL' && this.targetHasAuthAdEffective) return true;

			if (this.visible_user_is_sys_admin) return false;

			if (this.isSelfAuthorizedAdmin) return true;

			if (role_cd === 'ACT_ADM' && this.sole_admin_self) return true;

			if (this.actor_is_auth_ad_on_this_account && !this.visible_user_is_sys_admin) {
				const allowed = ['ANLYSIS', 'RPRT', 'SUP'];
				if (!allowed.includes(role_cd)) return true;
			}

			return false;
		},

		showUserList: function () {
			window.location.href = "/admin/users/" + this.email;
		},
		resetMessages: function () {
			this.form_errors = {};
			this.form_status = "";
		},
		addRolesArray(role_index) {
			this.resetMessages(true);
			const user_role_cd = this.filtered_roles[role_index].role_cd;

			if (user_role_cd === 'BILL' && this.targetHasAuthAdEffective) return;

			if (this.actor_is_auth_ad_on_this_account && !this.visible_user_is_sys_admin) {
				const allowed = ['ANLYSIS', 'RPRT', 'SUP'];
				if (!allowed.includes(user_role_cd)) return;
			}

			Vue.set(this.local_roles_array, user_role_cd, 0);

			if (user_role_cd === 'AUTH_AD') {
				this.ensureAuthorizedConstraints();
			}
			if (user_role_cd === 'ACT_ADM') {
				this.checkAllExceptAuthAdAndSelf();
			}
		},

		revertOrDeleteRole(user_role_cd) {
			if (this.roles_array.hasOwnProperty(user_role_cd) && this.roles_array[user_role_cd] === 1) {
				Vue.set(this.local_roles_array, user_role_cd, 1);
			} else {
				Vue.delete(this.local_roles_array, user_role_cd);
			}
		},
		deleteRolesArray: function (role_index) {
			this.resetMessages(true);
			const user_role_cd = this.filtered_roles[role_index].role_cd;

			this.revertOrDeleteRole(user_role_cd);
		},
		removeUnapprovedRoles: function () {
			for (let role_cd in this.local_roles_array) {
				if (this.local_roles_array.hasOwnProperty(role_cd) && this.local_roles_array[role_cd] === 1) {
					Vue.delete(this.local_roles_array, role_cd);
				}
			}
		},
		savePermissions: function () {
			this.resetMessages();
			this.form_status = "Saving...";
			this.removeUnapprovedRoles();
			const role_keys = Object.keys(this.local_roles_array);
			this.saving = true;

			this.$http.post('/admin/users/approve-account-roles',
				{
					user_id: this.user_id,
					email: this.email,
					account_nbr: this.account_nbr,
					role_keys: role_keys
				})
				.then(function (response) {
					this.$emit('updateUserData', this.local_roles_array);
					this.form_status = response.data.status;
				})
				.catch(function (data, status, request) {
					this.form_errors = data.body.errors[0];
					this.form_status = '';
				}).finally(() => this.saving = false);
		}
	},
	mounted() {
		this.copyRolesArray();
	}
}

</script>



// WEBPACK FOOTER //
// admin-user-role-list.vue?caf2b1dc